/**
 * 64卦详细特性数据
 * 包含每个卦的建议、关注点、态度、事业、财运、感情、健康等方面的详细解读
 */

export interface HexagramCharacteristic {
  advice: string;      // 核心建议
  focus: string;       // 关注重点
  attitude: string;    // 应持态度
  career: string;      // 事业发展
  wealth: string;      // 财运状况
  relationship: string; // 感情状况
  health: string;      // 健康提示
  timing: string;      // 时机把握
}

export const hexagramCharacteristics: Record<string, HexagramCharacteristic> = {
  "乾卦": {
    advice: "发挥天行健的精神，以坚韧不拔的意志面对挑战，积极进取但需防止过刚",
    focus: "关注领导能力的提升、事业开拓和个人品格修养，把握主动权",
    attitude: "保持刚健不息、自强不息的进取精神，同时注意刚柔并济",
    career: "正处于上升期，适合开创新事业或担任领导职务，但需谨慎行事避免盲目冒进",
    wealth: "财运旺盛，适合投资创业，但需注意风险控制，切忌过度自信",
    relationship: "感情方面主动积极，但需注意倾听对方意见，避免过于强势",
    health: "精力充沛，但需注意劳逸结合，防止过度劳累导致身体透支",
    timing: "当前时机极佳，是大展宏图的好时机，但需把握分寸，循序渐进"
  },
  
  "坤卦": {
    advice: "以柔克刚，用包容和耐心等待时机，顺势而为不可强求",
    focus: "关注团队协作、人际关系建设和内在修养的提升",
    attitude: "保持谦逊包容、厚德载物的柔和心态，以退为进",
    career: "适合辅助性工作，通过服务他人来实现自身价值，耐心等待机会",
    wealth: "财运平稳，适合稳健投资，不宜冒险，积少成多是关键",
    relationship: "感情温和顺从，注重维护和谐，但也要保持自我",
    health: "身体状况稳定，但需注意调养，防止过度操劳",
    timing: "当前宜守不宜攻，耐心等待，机会自会来临"
  },

  "屯卦": {
    advice: "万事开头难，需要坚持和耐心，不要轻易放弃初心",
    focus: "关注基础建设和资源积累，打好根基为未来发展做准备",
    attitude: "保持坚韧不拔的毅力，在困难中寻找突破口",
    career: "创业初期或新项目启动阶段，充满挑战但潜力巨大，需要坚持",
    wealth: "财运初显，需谨慎投资，避免大额支出，积累为主",
    relationship: "感情处于萌芽期，需要精心培育，不可操之过急",
    health: "注意预防疾病，加强锻炼，建立良好的生活习惯",
    timing: "时机尚未成熟，需要耐心等待和积极准备"
  },

  "蒙卦": {
    advice: "保持谦虚好学的态度，虚心求教，不耻下问",
    focus: "关注学习提升和经验积累，打好知识和技能基础",
    attitude: "保持空杯心态，以学习者的姿态面对一切",
    career: "适合学习新技能或转型发展，寻求良师指导事半功倍",
    wealth: "财运一般，需要通过学习提升来增加收入，避免投机",
    relationship: "感情需要相互学习理解，坦诚沟通很重要",
    health: "注意用脑过度，适当休息调整状态",
    timing: "正是学习成长的好时机，充实自己为将来做准备"
  },

  "需卦": {
    advice: "守正待时，不要急于求成，时机未到强求无益",
    focus: "关注时机把握和资源准备，蓄势待发",
    attitude: "保持沉稳耐心，相信好时机终会到来",
    career: "暂时遇到阻碍，需要耐心等待时机，做好充分准备",
    wealth: "财运需要等待，不宜急于投资，稳健为上",
    relationship: "感情需要时间培养，急于求成反而不利",
    health: "身体需要休养调理，不宜过度劳累",
    timing: "时机未到，需要耐心等待，同时做好准备工作"
  },

  "讼卦": {
    advice: "慎争戒讼，能和解尽量和解，避免两败俱伤",
    focus: "关注矛盾化解和关系修复，以和为贵",
    attitude: "保持理性客观，寻求双赢的解决方案",
    career: "工作中可能遇到纷争，需要智慧化解，避免正面冲突",
    wealth: "财运受阻，可能有经济纠纷，谨慎处理为好",
    relationship: "感情出现矛盾，需要沟通理解，避免激化",
    health: "注意情绪管理，避免因争执影响健康",
    timing: "不是行动的好时机，先解决矛盾再图发展"
  },

  "师卦": {
    advice: "在逆境中寻找顺境，统筹全局，化险为夷",
    focus: "关注团队领导和集体行动，发挥组织协调能力",
    attitude: "保持稳健谨慎的统帅风范，以正道行事",
    career: "适合承担管理职责，带领团队克服困难",
    wealth: "财运需要团队合作，众人拾柴火焰高",
    relationship: "感情需要责任担当，成为对方的依靠",
    health: "注意劳逸结合，不要承担过重压力",
    timing: "是展现领导才能的时机，但需稳扎稳打"
  },

  "比卦": {
    advice: "诚信团结，善于合作，以诚相待建立信任",
    focus: "关注人际关系和团队协作，互助共赢",
    attitude: "保持真诚友善的态度，以心换心",
    career: "适合合作项目，寻找志同道合的伙伴",
    wealth: "财运通过合作提升，共同投资需谨慎选择伙伴",
    relationship: "感情融洽，相互扶持，关系稳固",
    health: "身心愉悦，社交活动有益身心",
    timing: "是建立关系、寻求合作的好时机"
  },

  "小畜卦": {
    advice: "积蓄力量等待时机，小有储蓄但不可大动",
    focus: "关注资源积累和能力提升，做好准备工作",
    attitude: "保持谦逊低调，韬光养晦",
    career: "暂时受限，需要继续积累经验，不宜冒进",
    wealth: "财运小有积累，适合储蓄理财，不宜大额投资",
    relationship: "感情稳定发展，需要耐心培养",
    health: "身体状况良好，注意营养补充",
    timing: "积累阶段，时机尚未成熟"
  },

  "履卦": {
    advice: "脚踏实地，循序渐进，一步一个脚印",
    focus: "关注职业发展和技能提升，稳扎稳打",
    attitude: "保持踏实肯干的务实精神",
    career: "通过实干获得认可，职业发展稳步上升",
    wealth: "财运稳健增长，靠努力获得回报",
    relationship: "感情真诚朴实，细水长流",
    health: "保持规律作息，身体健康",
    timing: "稳步前进的好时机，贵在坚持"
  },

  "泰卦": {
    advice: "应时而变，把握机遇，天时地利人和",
    focus: "关注机遇把握和资源整合，顺势而为",
    attitude: "保持积极进取但不骄不躁",
    career: "事业顺利，适合扩张发展，但需居安思危",
    wealth: "财运亨通，投资有利，但需谨慎",
    relationship: "感情甜蜜顺遂，是好时光",
    health: "身心愉悦，精力充沛",
    timing: "运势极佳，是大展宏图的最佳时机"
  },

  "否卦": {
    advice: "不交不通时需韬光养晦，保存实力等待转机",
    focus: "关注自我修养和内功修炼，为转机做准备",
    attitude: "保持乐观但谨慎行事，不轻举妄动",
    career: "事业受阻，宜守不宜攻，等待时机",
    wealth: "财运不佳，避免投资，控制支出",
    relationship: "感情遇冷，需要反思调整",
    health: "注意情绪调节，避免抑郁",
    timing: "运势低迷，需要耐心等待转机"
  },

  "同人卦": {
    advice: "上下和同，团结合作，以大局为重",
    focus: "关注团队建设和共同目标，求同存异",
    attitude: "保持开放包容，与人为善",
    career: "适合团队合作项目，发挥协调能力",
    wealth: "通过合作共赢提升财运",
    relationship: "感情和谐，志同道合",
    health: "心情舒畅，有益健康",
    timing: "合作共赢的好时机"
  },

  "大有卦": {
    advice: "顺天依时，善用资源，保持谦逊",
    focus: "关注资源管理和成果分享，回馈社会",
    attitude: "保持感恩之心，不忘初心",
    career: "事业有成，但需善待下属，分享成果",
    wealth: "财运丰厚，适合投资布局",
    relationship: "感情美满，互相珍惜",
    health: "身体健康，精力旺盛",
    timing: "收获的好时机，但需居安思危"
  },

  "谦卦": {
    advice: "内高外低，谦虚谨慎，德行天下",
    focus: "关注品德修养和人格完善，低调行事",
    attitude: "保持谦逊有礼，虚怀若谷",
    career: "通过谦逊获得认可和支持",
    wealth: "财运平稳，厚积薄发",
    relationship: "以谦逊赢得尊重和爱",
    health: "心态平和，有益长寿",
    timing: "修身养性的好时机"
  },

  "豫卦": {
    advice: "顺时依势，把握机遇，但不可沉溺享乐",
    focus: "关注时机把握和资源利用，适度享受",
    attitude: "保持积极乐观，但需有度",
    career: "工作顺利，可以适当放松",
    wealth: "财运不错，可以享受成果",
    relationship: "感情愉悦，享受当下",
    health: "身心放松，注意适度",
    timing: "享受成果的时候，但不可过度"
  },

  "随卦": {
    advice: "随时变通，顺应时势，灵活应对",
    focus: "关注环境变化和适应能力，因时制宜",
    attitude: "保持灵活变通，不固执己见",
    career: "需要根据形势调整策略",
    wealth: "财运随势而动，把握机会",
    relationship: "感情需要相互适应",
    health: "注意环境变化对健康的影响",
    timing: "顺势而为的时机"
  },

  "蛊卦": {
    advice: "振疲起衰，整顿革新，拨乱反正",
    focus: "关注问题解决和改革创新，除旧布新",
    attitude: "保持改革决心，勇于担当",
    career: "需要整顿改革，清除弊端",
    wealth: "财务需要整顿，清理不良资产",
    relationship: "感情需要反思调整",
    health: "注意调理身体，改善不良习惯",
    timing: "改革整顿的关键时期"
  },

  "临卦": {
    advice: "教民保民，以身作则，承担责任",
    focus: "关注领导责任和下属培养，关心他人",
    attitude: "保持亲民爱民的情怀",
    career: "适合承担管理职责，培养团队",
    wealth: "财运上升，但需关注员工福利",
    relationship: "感情中需要更多关怀",
    health: "身体健康，注意他人健康",
    timing: "承担责任、关怀他人的时机"
  },

  "观卦": {
    advice: "观下瞻上，学习借鉴，反思总结",
    focus: "关注学习观察和经验总结，开阔视野",
    attitude: "保持谦虚学习的态度",
    career: "适合观察学习，提升见识",
    wealth: "观察市场，谨慎投资",
    relationship: "观察了解对方，增进理解",
    health: "观察身体变化，及时调理",
    timing: "学习观察、积累经验的时期"
  },

  "噬嗑卦": {
    advice: "刚柔相济，排除障碍，维护正义",
    focus: "关注问题解决和障碍清除，公平公正",
    attitude: "保持坚定立场，秉公处理",
    career: "清除工作障碍，维护秩序",
    wealth: "解决财务问题，清理债务",
    relationship: "化解矛盾，消除隔阂",
    health: "治疗疾病，恢复健康",
    timing: "解决问题、清除障碍的时机"
  },

  "贲卦": {
    advice: "饰外扬质，注重形象，内外兼修",
    focus: "关注形象提升和品质优化，美化环境",
    attitude: "保持内外兼修的平衡",
    career: "提升专业形象，注重细节",
    wealth: "适度投资于形象提升",
    relationship: "注重外表，但更重内在",
    health: "外表健康，内在调理",
    timing: "提升形象、优化品质的时期"
  },

  "剥卦": {
    advice: "顺势而止，保存实力，不可强行",
    focus: "关注风险防范和损失控制，及时止损",
    attitude: "保持冷静理智，接受现实",
    career: "事业受损，需要止损保护",
    wealth: "财运下滑，避免投资",
    relationship: "感情遇冷，需要反思",
    health: "注意身体预警，及时治疗",
    timing: "收缩保守的时期，不宜进取"
  },

  "复卦": {
    advice: "寓动于顺，休养生息，重新开始",
    focus: "关注恢复调整和重新出发，总结经验",
    attitude: "保持希望，相信新生",
    career: "事业恢复期，稳步重建",
    wealth: "财运开始回升，谨慎乐观",
    relationship: "感情复苏，重归于好",
    health: "身体恢复，注意调养",
    timing: "恢复重建、重新开始的时期"
  },

  "无妄卦": {
    advice: "无妄而得，顺其自然，不要妄动",
    focus: "关注自然法则和真实想法，不刻意追求",
    attitude: "保持真诚自然，不做作",
    career: "顺其自然发展，不强求",
    wealth: "意外之财可能，但不可贪",
    relationship: "真诚相待，自然发展",
    health: "顺应自然，养生为主",
    timing: "顺其自然、真诚待人的时期"
  },

  "大畜卦": {
    advice: "止而不止，积蓄力量，厚积薄发",
    focus: "关注能量积累和时机等待，充分准备",
    attitude: "保持耐心，积蓄实力",
    career: "积累经验，等待爆发",
    wealth: "财富积累，长期投资",
    relationship: "感情深厚，稳步发展",
    health: "强身健体，储备能量",
    timing: "积蓄力量、等待时机的时期"
  },

  "颐卦": {
    advice: "纯正以养，注重调养，谨言慎行",
    focus: "关注身心调养和饮食健康，修身养性",
    attitude: "保持纯正心态，养生为重",
    career: "工作稳定，注重调养",
    wealth: "财运平稳，重在养生",
    relationship: "感情需要精心培养",
    health: "注重养生，调理身体",
    timing: "调养身心、修身养性的时期"
  },

  "大过卦": {
    advice: "非常行动，果断决策，应对危机",
    focus: "关注危机应对和非常措施，果断行动",
    attitude: "保持果断勇气，敢于创新",
    career: "面临重大挑战，需非常之举",
    wealth: "财务危机，需果断处理",
    relationship: "感情危机，需要果断行动",
    health: "健康危机，及时就医",
    timing: "非常时期，需要非常手段"
  },

  "坎卦": {
    advice: "行险用险，以险克险，化险为夷",
    focus: "关注风险应对和危机处理，保持警惕",
    attitude: "保持冷静，勇于面对",
    career: "工作充满挑战，需要智慧应对",
    wealth: "财运波动，谨慎投资",
    relationship: "感情有波折，需要信任",
    health: "注意安全，防范意外",
    timing: "充满挑战的时期，需要谨慎"
  },

  "离卦": {
    advice: "附和依托，发挥专长，光明正大",
    focus: "关注专业技能和人脉拓展，借力发展",
    attitude: "保持热情明亮的积极心态",
    career: "依附明主，发挥特长",
    wealth: "财运光明，但需依靠他人",
    relationship: "感情热烈，但需要依附",
    health: "精力充沛，注意上火",
    timing: "发挥专长、借力发展的时期"
  },

  "咸卦": {
    advice: "相互感应，真诚交流，心心相印",
    focus: "关注情感交流和心灵沟通，真诚相待",
    attitude: "保持开放真诚，用心感受",
    career: "同事关系和谐，合作愉快",
    wealth: "财运通过交流提升",
    relationship: "感情深厚，心意相通",
    health: "心情愉悦，有益健康",
    timing: "交流沟通、建立感情的时期"
  },

  "恒卦": {
    advice: "恒心有成，持之以恒，不轻易改变",
    focus: "关注长期目标和持续努力，保持恒心",
    attitude: "保持坚持不懈的毅力",
    career: "事业稳定，贵在坚持",
    wealth: "财运稳健，长期投资",
    relationship: "感情稳定，长久经营",
    health: "保持良好习惯，长期受益",
    timing: "坚持到底、持之以恒的时期"
  },

  "遁卦": {
    advice: "遁世救世，适时退让，保存实力",
    focus: "关注战略退却和实力保存，以退为进",
    attitude: "保持从容，该退则退",
    career: "暂时退让，等待时机",
    wealth: "保守投资，避免损失",
    relationship: "适当距离，保持空间",
    health: "注意休息，避免透支",
    timing: "战略退却、保存实力的时期"
  },

  "大壮卦": {
    advice: "壮勿妄动，有力但需节制，勇而有谋",
    focus: "关注力量运用和策略规划，刚柔并济",
    attitude: "保持强大但谦逊",
    career: "事业强盛，但需谨慎",
    wealth: "财力雄厚，投资需理性",
    relationship: "感情强势，需要温柔",
    health: "体魄强健，注意节制",
    timing: "力量强大的时期，需要智慧运用"
  },

  "晋卦": {
    advice: "求进发展，积极进取，光明磊落",
    focus: "关注事业发展和晋升机会，主动出击",
    attitude: "保持积极向上的进取精神",
    career: "事业上升，晋升有望",
    wealth: "财运上升，适合投资",
    relationship: "感情进展，关系升温",
    health: "身体向好，精力充沛",
    timing: "进取发展、积极向上的时期"
  },

  "明夷卦": {
    advice: "晦而转明，韬光养晦，等待转机",
    focus: "关注内在修炼和智慧积累，暗中准备",
    attitude: "保持低调，内心坚定",
    career: "暂时受挫，韬光养晦",
    wealth: "财运不明，谨慎理财",
    relationship: "感情低谷，保持希望",
    health: "注意调养，等待康复",
    timing: "黑暗时期，但黎明将至"
  },

  "家人卦": {
    advice: "诚威治业，家和万事兴，重视家庭",
    focus: "关注家庭和谐和亲情培养，经营家庭",
    attitude: "保持温暖关爱，以家为重",
    career: "事业稳定，家庭支持",
    wealth: "家庭财务，共同理财",
    relationship: "亲情友情，温馨和睦",
    health: "家庭健康，互相关心",
    timing: "重视家庭、经营亲情的时期"
  },

  "睽卦": {
    advice: "异中求同，化解分歧，求同存异",
    focus: "关注矛盾化解和共识寻找，包容差异",
    attitude: "保持开放包容，寻求理解",
    career: "团队有分歧，需要协调",
    wealth: "投资分歧，需要沟通",
    relationship: "感情有隔阂，需要沟通",
    health: "身心不协调，需要调整",
    timing: "化解分歧、求同存异的时期"
  },

  "蹇卦": {
    advice: "险阻在前，谨慎前行，寻求帮助",
    focus: "关注困难应对和援助寻求，团结合作",
    attitude: "保持谨慎，不轻易冒险",
    career: "工作困难，需要支持",
    wealth: "财运受阻，寻求帮助",
    relationship: "感情困难，需要沟通",
    health: "健康受阻，及时就医",
    timing: "困难时期，需要谨慎和帮助"
  },

  "解卦": {
    advice: "柔道致治，化解困境，轻装前进",
    focus: "关注问题解决和负担释放，放下包袱",
    attitude: "保持宽容，释怀过往",
    career: "困境化解，轻松前行",
    wealth: "债务化解，财务改善",
    relationship: "矛盾化解，重归于好",
    health: "病情好转，恢复健康",
    timing: "化解困境、释放压力的时期"
  },

  "损卦": {
    advice: "损益制衡，有舍有得，合理取舍",
    focus: "关注资源优化和优先级排序，取舍有度",
    attitude: "保持理性，懂得取舍",
    career: "适当放弃，专注核心",
    wealth: "控制开支，理性消费",
    relationship: "适当妥协，维护关系",
    health: "减少负担，轻松养生",
    timing: "取舍抉择、优化资源的时期"
  },

  "益卦": {
    advice: "损上益下，互利共赢，分享成果",
    focus: "关注利益分享和合作共赢，回馈他人",
    attitude: "保持分享精神，互惠互利",
    career: "事业有益，团队共赢",
    wealth: "财运增长，分享财富",
    relationship: "互相帮助，共同成长",
    health: "相互关心，共同健康",
    timing: "互利共赢、分享成果的时期"
  },

  "夬卦": {
    advice: "决而能和，果断决策，但留有余地",
    focus: "关注决断力和谈判技巧，刚柔并济",
    attitude: "保持果断明智的决断精神",
    career: "需要果断决策，清除障碍",
    wealth: "财务决策，果断行动",
    relationship: "感情抉择，但需温和",
    health: "及时治疗，果断行动",
    timing: "果断决策、清除障碍的时期"
  },

  "姤卦": {
    advice: "天下有风，防微杜渐，警惕隐患",
    focus: "关注潜在风险和细节把控，未雨绸缪",
    attitude: "保持警觉，防患未然",
    career: "注意小问题，避免扩大",
    wealth: "警惕风险，控制投资",
    relationship: "注意细节，防止裂痕",
    health: "预防疾病，定期检查",
    timing: "警惕风险、防微杜渐的时期"
  },

  "萃卦": {
    advice: "荟萃聚集，资源整合，团结力量",
    focus: "关注资源聚集和团队建设，凝聚人心",
    attitude: "保持团结协作的精神",
    career: "团队聚集，合力发展",
    wealth: "资金聚集，集中投资",
    relationship: "亲友聚集，增进感情",
    health: "凝聚能量，强身健体",
    timing: "聚集资源、团结协作的时期"
  },

  "升卦": {
    advice: "柔顺谦虚，步步高升，稳步前进",
    focus: "关注晋升发展和能力提升，循序渐进",
    attitude: "保持谦逊，稳步上升",
    career: "事业上升，职位晋升",
    wealth: "财运上升，收入增加",
    relationship: "感情升温，关系进展",
    health: "身体向好，精力提升",
    timing: "上升发展、稳步前进的时期"
  },

  "困卦": {
    advice: "困境求通，坚持信念，寻找突破",
    focus: "关注困境突破和希望寻找，保持信心",
    attitude: "保持坚韧，相信转机",
    career: "工作困难，需要突破",
    wealth: "财务困难，开源节流",
    relationship: "感情困境，需要努力",
    health: "身体不适，积极治疗",
    timing: "困境时期，需要坚持和突破"
  },

  "井卦": {
    advice: "求贤若渴，开发潜能，持续供给",
    focus: "关注人才发掘和资源开发，长期建设",
    attitude: "保持开放学习，不断进取",
    career: "发掘潜力，持续发展",
    wealth: "稳定收入，持续经营",
    relationship: "深挖感情，持久维护",
    health: "调理身体，长期养生",
    timing: "开发潜能、持续发展的时期"
  },

  "革卦": {
    advice: "顺天应人，变革创新，顺应时代",
    focus: "关注变革创新和改革发展，与时俱进",
    attitude: "保持变革勇气，顺应趋势",
    career: "需要变革转型，创新发展",
    wealth: "投资新领域，把握机遇",
    relationship: "关系变革，重新定位",
    health: "改变习惯，调整状态",
    timing: "变革创新、顺应时代的时期"
  },

  "鼎卦": {
    advice: "稳重图变，守正创新，循序渐进",
    focus: "关注创新变革和制度建设，稳中求进",
    attitude: "保持稳重创新的变革精神",
    career: "稳定中创新，制度化发展",
    wealth: "稳健投资，创新项目",
    relationship: "稳定关系，注入新意",
    health: "稳定调理，创新养生",
    timing: "稳重创新、制度建设的时期"
  },

  "震卦": {
    advice: "临危不乱，从容应对，化危为机",
    focus: "关注危机应对和心理素质，保持冷静",
    attitude: "保持镇定，从容不迫",
    career: "面对变动，沉着应对",
    wealth: "市场波动，冷静分析",
    relationship: "关系震荡，理性处理",
    health: "突发状况，及时应对",
    timing: "应对变动、保持冷静的时期"
  },

  "艮卦": {
    advice: "动静适时，该止则止，把握分寸",
    focus: "关注节奏把握和分寸掌控，张弛有度",
    attitude: "保持定力，知进退",
    career: "适时停顿，思考调整",
    wealth: "停止投资，观望市场",
    relationship: "保持距离，给予空间",
    health: "停止劳累，休息调养",
    timing: "停止反思、调整节奏的时期"
  },

  "渐卦": {
    advice: "渐进蓄德，循序渐进，稳扎稳打",
    focus: "关注逐步发展和品德积累，不急不躁",
    attitude: "保持耐心，稳步前进",
    career: "逐步晋升，稳步发展",
    wealth: "逐步积累，稳健增长",
    relationship: "感情渐进，稳定发展",
    health: "渐进调理，持续改善",
    timing: "稳步前进、循序渐进的时期"
  },

  "归妹卦": {
    advice: "立家兴业，承担责任，稳定发展",
    focus: "关注家庭建设和责任承担，成家立业",
    attitude: "保持责任感，珍惜家庭",
    career: "稳定发展，承担责任",
    wealth: "家庭理财，稳健投资",
    relationship: "建立家庭，承诺责任",
    health: "家庭健康，共同关注",
    timing: "成家立业、承担责任的时期"
  },

  "丰卦": {
    advice: "日中则斜，盛极思衰，居安思危",
    focus: "关注风险预警和持续发展，保持警惕",
    attitude: "保持清醒，不骄不躁",
    career: "事业鼎盛，但需谨慎",
    wealth: "财运丰厚，需要规划",
    relationship: "感情美满，珍惜维护",
    health: "身体健康，预防保健",
    timing: "鼎盛时期，需要居安思危"
  },

  "旅卦": {
    advice: "依义顺时，随遇而安，谨慎行事",
    focus: "关注环境适应和机会把握，灵活应对",
    attitude: "保持谦逊谨慎，随遇而安",
    career: "工作变动，灵活应对",
    wealth: "财务流动，谨慎理财",
    relationship: "关系变动，珍惜当下",
    health: "注意安全，保重身体",
    timing: "变动时期，需要谨慎适应"
  },

  "巽卦": {
    advice: "谦逊受益，柔顺渗透，顺势而为",
    focus: "关注柔性力量和渗透影响，以柔克刚",
    attitude: "保持谦逊温和，润物无声",
    career: "柔性管理，潜移默化",
    wealth: "稳健投资，循序渐进",
    relationship: "温柔体贴，细心呵护",
    health: "温和调理，持续养生",
    timing: "柔性影响、循序渐进的时期"
  },

  "兑卦": {
    advice: "刚内柔外，和悦待人，内刚外柔",
    focus: "关注沟通技巧和人际和谐，内外兼修",
    attitude: "保持喜悦平和，以和为贵",
    career: "和谐合作，愉快共事",
    wealth: "和气生财，互利共赢",
    relationship: "感情和悦，相处愉快",
    health: "心情愉悦，身心健康",
    timing: "和谐愉悦、以和为贵的时期"
  },

  "涣卦": {
    advice: "拯救涣散，重新凝聚，整合资源",
    focus: "关注团队整合和人心凝聚，重建秩序",
    attitude: "保持包容，重建信任",
    career: "整合团队，重建秩序",
    wealth: "整合资源，优化配置",
    relationship: "修复关系，重新凝聚",
    health: "调整状态，恢复元气",
    timing: "整合重建、凝聚人心的时期"
  },

  "节卦": {
    advice: "万物有节，适度节制，把握分寸",
    focus: "关注理财规划和时间管理，节制有度",
    attitude: "保持自律自强的节制心态",
    career: "工作有度，劳逸结合",
    wealth: "节制开支，合理规划",
    relationship: "保持距离，适度关心",
    health: "节制饮食，规律作息",
    timing: "节制调整、把握分寸的时期"
  },

  "中孚卦": {
    advice: "诚信立身，真诚待人，以诚感人",
    focus: "关注诚信建设和信任培养，真诚为本",
    attitude: "保持真诚，以信待人",
    career: "诚信经营，赢得信任",
    wealth: "诚信理财，稳健发展",
    relationship: "真诚相待，建立信任",
    health: "真实面对，诚心调理",
    timing: "诚信为本、真诚待人的时期"
  },

  "小过卦": {
    advice: "行动有度，小心谨慎，不可过分",
    focus: "关注细节把握和行为规范，谨小慎微",
    attitude: "保持谨慎，小心行事",
    career: "注意细节，避免失误",
    wealth: "小额投资，谨慎理财",
    relationship: "小心呵护，细心体贴",
    health: "注意小病，及时治疗",
    timing: "谨慎行事、注意细节的时期"
  },

  "既济卦": {
    advice: "盛极将衰，功成身退，未雨绸缪",
    focus: "关注风险防范和持续发展，善始善终",
    attitude: "保持清醒，居安思危",
    career: "事业有成，但需警惕",
    wealth: "财务稳定，需要规划",
    relationship: "感情稳定，需要维护",
    health: "身体健康，预防为主",
    timing: "成功时期，需要未雨绸缪"
  },

  "未济卦": {
    advice: "事业未竟,继续努力，前途光明",
    focus: "关注持续奋斗和目标实现，不懈追求",
    attitude: "保持希望，继续前行",
    career: "事业未成，继续努力",
    wealth: "财运待开，积极争取",
    relationship: "感情发展，需要努力",
    health: "健康改善，持续调理",
    timing: "未完成时期，需要继续努力"
  }
};